module.exports = "<ion-button *ngIf=\"showChangeState\"  (click)=\"changeState()\" slot=\"end\" type=\"button\" color=\"primary\">Cambiar estado</ion-button>\n"